export enum NotificationPlacement {
  Bottom = "bottom",
  TOP = "top"
}

export enum NotificationStatus {
  ERROR = "error",
  SUCCESS = "success",
  WARNING = "warning"
}

export interface INotification {
  closeable?: boolean,
  duration?: number,  // duration in milliseconds
  placement?: NotificationPlacement,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  statusIcon?: any,
  text?: string,
  type?: NotificationStatus,
}

export const defaultNotificationConfig: INotification = {
  closeable: true,
  duration: 3000,
  placement: NotificationPlacement.TOP,
  statusIcon: null,
  text: "This is a sample notification message",
  type: NotificationStatus.SUCCESS,
};

function pluralizeUnit (value: number, unit: string) {
  return `${value} ${unit}${value !== 1
    ? 's'
    : ''}`;
}

export function formatDurationSecToHR (durationSec = 0) {
  const minutes = Math.floor(durationSec / 60);
  const seconds = durationSec % 60;

  const parts = [];
  if (minutes > 0) {
    parts.push(pluralizeUnit(minutes, 'min'));
  }

  if (seconds > 0) {
    parts.push(pluralizeUnit(seconds, 'sec'));
  }

  return parts.join(" and ");
}

export function maskSensitiveInput (input?: string, replaceCharacter: '*' = '*', revealLastCharsCount: number = 4) {
  if (!input) {
    return input;
  }
  try {
    return replaceCharacter.repeat(input.length - revealLastCharsCount) + input.slice(-1 * revealLastCharsCount);
  } catch (e) {
    console.log(e);
  }
}
